export enum SelectedTab {
  Home = 'Home',
  /** Documents workspace chats home. Distinct from gecko `/home`. */
  DocumentsHome = 'DocumentsHome',
  Inbox = 'Inbox',
  Assets = 'Assets',
  Alerts = 'Alerts',
  Ships = 'Ships',
  Inspections = 'Inspections',
  FleetAnalysis = 'Fleet Analysis',
  Publisher = 'Publisher',
  HealthPlans = 'Health Plans',
  Budgeting = 'Budgeting',
  InspectionScheduling = 'Inspection Scheduling',
  AvailabilityPlanning = 'Availability Planning',
  Overview = 'Overview',
  Cases = 'Cases',
  Exploration = 'Exploration',
  Explorer = 'Explorer',
  Prism = 'Prism',
  PartsThread = 'Parts Thread',
  JobsOverview = 'Jobs Overview',
  Walkdowns = 'Walkdowns',
  Reporting = 'Reporting',
  InventoryManagement = 'Inventory Management',
  Maximo = 'Maximo',
  SystemLens = 'System Lens',
  PointCloud = 'Point Cloud',
  ProcessFlowDiagrams = 'Process Flow Diagrams',
  ValueStories = 'Value Stories',
  ProcessData = 'Process Data',
  AnomalyDetection = 'Anomaly Detection',
  Documents = 'Documents',
  CmmsExplorer = 'CMMS Explorer',
  LotoReports = 'LOTO Reports',
  FimMetrics = 'FIM Metrics',
  Libra = 'Libra',
  ProductionDashboard = 'Production Dashboard',
  VirtualReports = 'Virtual Reports',
  NiiDashboard = 'NII Dashboard',
  EntryBrowser = 'Entry Browser',
  Pipelines = 'Pipelines',
  PipelineFleet = 'Pipeline Fleet',
  Notifications = 'Notifications',
  SiteContextMonitoring = 'Site Context & Monitoring',
  FacilityModel = 'FacilityModel',
  ModelOperations = 'ModelOperations',
  WeldMap = 'Weld Map',
  Logbook = 'Logbook',
  NnppOrders = 'NNPP Orders',
  NnppReports = 'NNPP Reports',
  NnppImports = 'NNPP Imports',
  NnppComponents = 'NNPP Components',
}
